<template>
    <div id="player"></div>
    <div>
        <iframe id="iframe-campaign-video" :width="`${w}`" :height="`${h}`"
            :src="`${videoUrl}?autoplay=1&showinfo=0&controls=0&start=0&enablejsapi=1`" title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen="true"></iframe>
    </div>
</template>

<script>
export default {
    name: 'youtube-video',
    props: {
        videoUrl: String,
        h: String,
        w: String
    },
    emits: ["ready", "start", "end"],
    data() {
        return {
            
        }
    },
    setup(props, context) {
        // 2. This code loads the IFrame Player API code asynchronously.
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        // console.log(firstScriptTag);
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        const videoStates = {
                ended: 0,
                buffering: 3,
                paused: 2
            }
        window.addEventListener('message', message => {
            try {
                let eventData = JSON.parse(message.data)
                if (eventData.event === "infoDelivery") return
                if (eventData.event === "onStateChange") {
                    if(eventData.info === videoStates.buffering) context.emit('start')
                    if(eventData.info === videoStates.ended) context.emit('end')
                }
                if (eventData.event === "onReady") context.emit('ready')
            } catch(e) {
                // do nothing
            }
        });
    },
    mounted() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
